import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'

/** Small confirm box that states the impact ("holds 3 open shipments…") instead of the browser's confirm(). */
export default function ConfirmDialog({ open, title, message, confirmLabel = 'Continue', danger = false, loading = false, onConfirm, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth PaperProps={{ sx: { borderRadius: '8px' } }}>
      <DialogTitle sx={{ fontSize: 15, fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent><Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{message}</Typography></DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <LoadingButton variant='contained' color={danger ? 'error' : 'primary'} loading={loading} onClick={onConfirm}>{confirmLabel}</LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
